var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMmsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    "aria-hidden": "true",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 15.5228 15.5228 20 10 20C8.43535 20 6.95464 19.6407 5.63587 19H3C1.89543 19 1 18.1046 1 17V14.3641C0.359342 13.0454 0 11.5646 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM4.75 6.75C4.75 5.64543 5.64543 4.75 6.75 4.75H13.25C14.3546 4.75 15.25 5.64543 15.25 6.75V13.25C15.25 14.3546 14.3546 15.25 13.25 15.25H6.75C5.64543 15.25 4.75 14.3546 4.75 13.25V6.75ZM12.3333 9.41667C12.9777 9.41667 13.5 8.89433 13.5 8.25C13.5 7.60567 12.9777 7.08333 12.3333 7.08333C11.689 7.08333 11.1667 7.60567 11.1667 8.25C11.1667 8.89433 11.689 9.41667 12.3333 9.41667ZM8.25 11.75L5.91667 14.0833H14.0833L11.1667 11.1667L9.41667 12.9167L8.25 11.75Z",
    fill: "#307FE2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmsIcon);
export default __webpack_public_path__ + "static/media/mms_icon.c099d8bcc9976253abf3807fc6d1144b.svg";
export { ForwardRef as ReactComponent };